import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-star-rating-summary',
  templateUrl: './star-rating-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent],
})
export class StarRatingSummaryComponent {
  @Input()
  public overallStars!: number | undefined;

  @Input()
  public layout: 'open' | 'pill' = 'pill';

  @Input()
  @HostBinding('style.font-size')
  public fontSizePx?: string;

  @HostBinding()
  public get class(): string {
    return `p-1 ${this.ratingStyles}`;
  }

  public get ratingStyles(): string {
    switch (this.layout) {
      case 'open':
        return 'inline-flex flex-row-reverse justify-end items-center font-medium ';
      case 'pill':
        return 'inline-flex items-center rounded-full bg-caution-50 text-white px-2';
    }
  }
}
